/* Ayudate · Cancelar una tutoría pagada
   Un solo modal para los dos paneles: el estudiante lo abre desde sus
   próximas reuniones (DashboardEstudiante.jsx) y el tutor desde las suyas
   (DashboardTutor.jsx). Lo único que cambia entre los dos es quién aparece
   del otro lado y qué dice la política, así que eso entra por props y el
   resto —el textarea, el contador, la confirmación, la traducción de los
   errores del servidor— vive una sola vez acá.

   El componente no llama a la API: recibe `onCancelar(motivo)`, que es
   quien sabe con qué sesión y contra qué endpoint hablar. Así el panel se
   queda con lo suyo (la sesión viva, mandar a /login si venció) y este
   archivo con lo suyo (el formulario). */

import React, { useState } from "react";
import { Capa } from "./Capa";
import { ErrorApi } from "../api";

/* Espeja MOTIVO_CANCELACION_MIN/MAX de apps-script.gs: acá se avisa antes de
   mandar, pero el servidor lo vuelve a validar — nunca se confía del
   navegador. */
export const MOTIVO_MIN = 10;
export const MOTIVO_MAX = 300;

/* El servidor devuelve códigos, no frases (ver intentar() en apps-script.gs).
   Traducirlos acá es lo que separa un "revise los datos" genérico de saber
   que la sesión ya la canceló la otra persona hace un minuto. */
const POR_CODIGO = {
  YA_CANCELADA: "Esta tutoría ya estaba cancelada — puede que la haya cancelado "
    + "la otra persona. Cierre y recargue el panel para verla al día.",
  NO_CANCELABLE: "Esta tutoría ya no se puede cancelar desde acá. Si necesita algo "
    + "con ella, repórtela como incidente y el equipo le da seguimiento.",
  SESION_TERMINADA: "Esa sesión ya pasó, así que no hay nada que cancelar. Si el "
    + "tutor no se presentó, repórtelo como incidente.",
  NO_AUTORIZADO: "Esta tutoría no aparece como suya.",
  SOLICITUD_INVALIDA: "No encontramos esa tutoría. Recargue el panel y pruebe de nuevo.",
  MOTIVO_CORTO: `Escriba al menos ${MOTIVO_MIN} caracteres.`,
  MOTIVO_LARGO: `El motivo no puede pasar de ${MOTIVO_MAX} caracteres.`,
  OCUPADO: "Hay otra cancelación de esta misma tutoría en curso. Espere unos "
    + "segundos y recargue el panel.",
};

export function CancelarSesion({ titulo, resumen, aviso, onCancelar, onCerrar, onListo }) {
  const [motivo, setMotivo] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState("");

  const limpio = motivo.trim();
  const corto = limpio.length < MOTIVO_MIN;

  const enviar = async () => {
    if (corto || enviando) return;
    setEnviando(true); setError("");
    try {
      await onCancelar(limpio);
      onListo();
    } catch (err) {
      const codigo = err instanceof ErrorApi ? err.codigo : null;
      setError(POR_CODIGO[codigo] || err.message || "No pudimos cancelar la tutoría.");
      setEnviando(false);
    }
  };

  return (
    <Capa onCerrar={onCerrar} etiqueta="Cancelar tutoría" confirmarSalida={limpio.length > 0}>
      <div className="mdl">
        <div className="mdl-h">
          <h3>{titulo}</h3>
          <button className="x" aria-label="Cerrar" onClick={onCerrar}>×</button>
        </div>
        <div className="mdl-b">
          <p style={{ margin: "0 0 6px" }}>{resumen}</p>
          <p className="ayuda" style={{ margin: "0 0 16px" }}>{aviso}</p>

          {error && <div className="error" role="alert" style={{ marginBottom: 14 }}>{error}</div>}

          <label className="lb" htmlFor="motivo-cancelacion" style={{ marginTop: 0 }}>
            ¿Por qué la cancela?
          </label>
          <textarea id="motivo-cancelacion" className="in ta" rows={3} maxLength={MOTIVO_MAX}
            placeholder="Ej: se me atravesó un examen a la misma hora y no puedo llegar."
            value={motivo} onChange={(e) => setMotivo(e.target.value)} />
          <p className={`ayuda ${corto ? "mal" : ""}`} style={{ margin: "6px 0 18px" }}>
            {corto
              ? `${limpio.length} de ${MOTIVO_MIN} caracteres mínimo`
              : `${motivo.length}/${MOTIVO_MAX}`}
          </p>

          <div className="fila-acciones">
            <button className="btn" onClick={onCerrar} disabled={enviando}>
              Mejor no
            </button>
            <button className="btn btn-danger" onClick={enviar} disabled={corto || enviando}>
              {enviando ? "Cancelando…" : "Sí, cancelar la tutoría"}
            </button>
          </div>
        </div>
      </div>
    </Capa>
  );
}
